import { useAuth } from '@/contexts/AuthContext';
import { Building2, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Guard component that blocks access for authenticated users
 * who have no company_users association (company_id is null).
 * Renders a friendly "no company" page instead of letting
 * downstream components crash with non-null assertion errors.
 */
export function CompanyGuard({ children }: { children: React.ReactNode }) {
  const { user, logout } = useAuth();

  // If user is loaded but has no company association, show blocking page
  if (user && !user.company_id) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-6 p-6">
        <Building2 className="w-14 h-14 text-muted-foreground" />
        <div className="text-center space-y-2 max-w-md">
          <h1 className="text-xl font-semibold text-foreground">Ingen virksomhed tilknyttet</h1>
          <p className="text-sm text-muted-foreground">
            Din brugerkonto er ikke tilknyttet en virksomhed endnu.
            Kontakt din administrator for at blive tilføjet.
          </p>
        </div>
        <Button variant="outline" size="sm" onClick={logout} className="gap-2">
          <LogOut className="w-4 h-4" />
          Log ud
        </Button>
      </div>
    );
  }

  return <>{children}</>;
}
